import { render, staticRenderFns } from "./MainSlot.vue?vue&type=template&id=75851ea6"
import script from "./MainSlot.vue?vue&type=script&lang=js"
export * from "./MainSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports